import { GDFWmoVolcano2CloudRecord } from '../../../gdf/type';

export default function WmoVolcanoAshCloud2Tooltip({ record }: { record: GDFWmoVolcano2CloudRecord }) {
    return (
        <div>
            <div>Ash cloud</div>
            <div style={{ display: 'grid', gridTemplateColumns: 'max-content auto', columnGap: '1rem', alignItems: 'center' }}>
                <div>Base:</div>
                <div>{record.base === 0 ? 'SFC' : record.base?.toString()}</div>

                <div>Tops:</div>
                <div>{record.tops ?? '-'}</div>

                <div>Concentration:</div>
                <div>
                    <span>{record.concentration === null ? '-' : (record.concentration / 100).toFixed(2)} </span>
                    {record.concentration !== null &&
                        // prettier-ignore
                        <span> mg/m<sup>3</sup></span>}
                </div>
            </div>
        </div>
    );
}
